// extracted by mini-css-extract-plugin
export default {"captcha":"Captcha_captcha__MvQjl","captchaField":"Captcha_captchaField__hf0N4"};